import React from 'react';
import LinuxAlternativesLinkHub from './LinuxAlternativesLinkHub';

function App() {
  return <LinuxAlternativesLinkHub />;
}

export default App;
